var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-layout',[_c('header-inf',_vm._g({attrs:{"id":_vm.id,"userInfo":_vm.userInfo},on:{"getData":_vm.getData}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }